var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadDocument20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Download-Document-20x20",
    stroke: "none",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mac/Monochrome/48x48/cloud.arrow.up",
    transform: "translate(1 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11H3.638C1.792 10.944.307 9.488.252 7.68L.25 7.575c0-1.856 1.507-3.367 3.387-3.422l.171-.001C4.421 1.766 6.625 0 9.25 0s4.829 1.766 5.442 4.152l.064-.001c1.93 0 3.494 1.533 3.494 3.424 0 1.822-1.45 3.31-3.281 3.419l-.107.004L12.75 11",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "rotate(-180 5.28 8.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M1.308.512v9.25"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    stroke: "currentColor",
    d: "M6.25 15.25l4 4 4-4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocument20);
export default __webpack_public_path__ + "static/media/download-document-20.a751889a.svg";
export { ForwardRef as ReactComponent };